import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faUserCog,
  faGripHorizontal,
  faSearch,
  faTimes,
  faCheck,
  faCheckDouble,
  faBellSlash,
  faBell as faBellSolid,
  faEllipsisV,
} from '@fortawesome/free-solid-svg-icons'

import {
  faQuestionCircle,
  faUser,
  faBell,
  faTrashAlt,
  faEnvelope,
  faEnvelopeOpen,
} from '@fortawesome/free-regular-svg-icons'

library.add(
  faQuestionCircle,
  faUserCog,
  faGripHorizontal,
  faUser,
  faSearch,
  faTimes,
  faCheck,
  faCheckDouble,
  faBell,
  faBellSolid,
  faBellSlash,
  faEllipsisV,
  faTrashAlt,
  faEnvelope,
  faEnvelopeOpen,
)
